import { render, staticRenderFns } from "./GpsProfileList.vue?vue&type=template&id=0bf4b6b1"
import script from "./GpsProfileList.vue?vue&type=script&lang=js"
export * from "./GpsProfileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports